// extracted by mini-css-extract-plugin
module.exports = {"fc-follow-btn":"styles_fc-follow-btn__cnYow","followed":"styles_followed__Tjr3s","loadingBtn":"styles_loadingBtn__UahdT"};